export default {
    mapSettings: []
};
